import {Layout} from 'antd';
import React, {useCallback, useMemo} from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import LoadingScreen from 'screens/loading.screen';
import SidebarContainer from './side-bar.container';
import {useDispatch, useSelector} from 'react-redux';
import {RootReducerType} from 'model/reducers/RootReducerType';
import classNames from 'classnames';
import {saveSettingAction} from 'domain/actions/app.action';
import UrlConfig from 'config/url.config';
import HeaderContainer from './header.container';

type ContainerProps = {
  title: string;
  header?: React.ReactNode;
  children: React.ReactNode;
};

const Container: React.FC<ContainerProps> = (props: ContainerProps) => {
  const {children} = props;
  const dispatch = useDispatch();
  const location = useLocation();
  
  const userReducer = useSelector(
    (state: RootReducerType) => state.userReducer
  );
  const collapse = useSelector(
    (state: RootReducerType) => state.appSettingReducer.collapse
  );
  const collapsed = useMemo(() => (collapse ? collapse : false), [collapse]);
  const {isLogin, isLoad: isLoadUser, account} = userReducer;
  const onCollapsed = useCallback(
    () => {
      dispatch(saveSettingAction({collapse: !collapsed}));
    },
    [collapsed, dispatch]
  );
  if (isLoadUser && !isLogin) {
    return (
      <Navigate to={`${UrlConfig.LOGIN}?returnUrl=${location.pathname}`} replace />
    );
  }
  return (
    <Layout>
      <LoadingScreen />
      <HeaderContainer account={account} onCollapse={onCollapsed} />
      <Layout>
        <SidebarContainer
          collapsed={collapsed}
          path={location.pathname}
        />
        <Layout.Content className={classNames('container', collapsed && 'collapsed')}>
          {children}
        </Layout.Content>
      </Layout>
    </Layout>
  );
};

export default Container;
